import { Routes } from '@angular/router';

import { UserRouteAccessService } from '../services';

import {
    auditsRoute,
    configurationRoute,
    docsRoute,
    healthRoute,
    logsRoute,
    metricsRoute,
    UPDATES_ROUTE,
    UPDATES_POPUPS_ROUTES,
    userMgmtRoute,
    userDialogRoute
} from './';

const ADMIN_ROUTES = [
    auditsRoute,
    configurationRoute,
    docsRoute,
    healthRoute,
    logsRoute,
    ...userMgmtRoute,
    metricsRoute,
    UPDATES_ROUTE
];

export const adminState: Routes = [
    {
        path: '',
        data: {
            authorities: ['ROLE_SUPER_ADMIN']
        },
        canActivate: [UserRouteAccessService],
        children: ADMIN_ROUTES
    },
    ...userDialogRoute,
    ...UPDATES_POPUPS_ROUTES
];



// WEBPACK FOOTER //
// ./src/main/webapp/app/admin/admin.route.ts